export const currencyDigits = currency => new Intl.NumberFormat('en-US',{style:'currency',currency}).resolvedOptions().maximumFractionDigits;
export const formatMoney = (minor,currency) => new Intl.NumberFormat('en-US',{style:'currency',currency:currency.toUpperCase()}).format(minor / 10 ** currencyDigits(currency));
export const majorAmount = (minor,currency) => (minor / 10 ** currencyDigits(currency)).toFixed(currencyDigits(currency));
export function minorAmount(value,currency) {
  if(!currency || !/^\d+(\.\d+)?$/.test(String(value))) return NaN;
  const places=currencyDigits(currency);const [whole,fraction='']=String(value).split('.');
  if(fraction.length>places)return NaN;
  const wholeNumber=Number(whole);
  if(!Number.isSafeInteger(wholeNumber))return NaN;
  const result=wholeNumber * 10 ** places + Number(fraction.padEnd(places,'0') || '0');
  return Number.isSafeInteger(result)?result:NaN;
}
